import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Notifications from '@kyvg/vue3-notification'
// import VueClipboard from 'vue3-clipboard'
const VueClipboard = require('vue3-clipboard')
// require('@/assets/js/ya.js')
// require('@/assets/js/tus.js')
window.logsnag = new window.LogSnag({
  token: '311ed0e8775178932e7bd08793157321',
  project: 'portret',
})
createApp(App).use(store).use(Notifications).use(VueClipboard).use(router).mount("#app");
